export default __webpack_public_path__ + "static/media/web-editor-image.be4c7f7b.png";